export enum SetupStoreId {
  App = 'app-store',
  Theme = 'theme-store',
  Auth = 'auth-store',
  Route = 'route-store',
  Tab = 'tab-store',
  Dict = 'dict-store',
  Version = 'version-store',
  Org = 'org-store'
}

export enum DateTimePattern {
  Date = 'YYYY-MM-DD',
  Time = 'HH:mm:ss',
  DateTime = 'YYYY-MM-DD HH:mm:ss'
}
